import { FunctionComponent, useMemo } from 'react';

import CardBodyText from 'components/CardBodyText';

import { COPY } from './constants';

export interface SatNoteFormInitialNoticeProps {
  isIntroduced?: boolean;
  isSupplyOnly?: boolean;
}

const SatNoteFormInitialNotice: FunctionComponent<
  SatNoteFormInitialNoticeProps
> = ({ isIntroduced = false, isSupplyOnly = false }) => {
  const line1 = useMemo(() => {
    if (isIntroduced) return COPY.introduced.line1;
    if (isSupplyOnly) return COPY.supplyOnly.line1;
    return COPY.standard.line1;
  }, [isIntroduced, isSupplyOnly]);
  const line2 = useMemo(() => {
    if (isIntroduced) return COPY.introduced.line2;
    if (isSupplyOnly) return COPY.supplyOnly.line2;
    return COPY.standard.line2;
  }, [isIntroduced, isSupplyOnly]);
  return (
    <>
      <CardBodyText>{line1}</CardBodyText>
      <CardBodyText>{line2}</CardBodyText>
    </>
  );
};

export default SatNoteFormInitialNotice;
